import queryString from "query-string";
const isDevelopment = process.env.NODE_ENV === "development";
export const APP_NAVIGATE_URL = isDevelopment
  ? "https://truyxuat.cachinhbong.com/"
  : process.env["REACT_APP_URI"] || "https://truyxuat.cachingbong.com/";


export const API_CORE_URI = isDevelopment
  ? "https://getway.cachinhbong.com/api/admin/"
  : process.env["REACT_APP_API_CORE_URI"] || "https://getway.cachinhbong.com/api/admin/";

  export const API_DMS_URI = isDevelopment
  ? "https://getway.cachinhbong.com/api/dms/"
  : process.env["REACT_APP_API_DMS_URI"] || "https://getway.cachinhbong.com/api/dms/";

export const API_SPATIAL_URI = isDevelopment
  ? "https://getway.cachinhbong.com/api/spatial/"
  : process.env["REACT_APP_API_SPATIAL_URI"] ||
    "https://getway.cachinhbong.com/api/spatial/";


export const API_GEOSERVER_URI = isDevelopment
  ? "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/wms"
  : process.env["REACT_APP_API_GEO_URI"] ||
    "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/wms";
export const API_GEOSERVER_URI_QUERY = isDevelopment
  ? "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/ows"
  : process.env["REACT_APP_API_GEO_URI_QUERY"] ||
    "https://geoserver.cachinhbong.com/geoserver/CaChinhBong/ows";
    
 

var CurrentUser = null;
export function setCurrentUser2(user) {
  CurrentUser = user;
}

function getHeaders() {
  if (CurrentUser) {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + CurrentUser.access_token
    };
  }

  return { "Content-Type": "application/json" };
}
function getHeaderFile() {
  if (CurrentUser) {
    return {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + CurrentUser.access_token
    };
  }

  return { "content-type": "multipart/form-data" };
}

export function callAPI({ method, path, data }) {
  if (method !== "GET" && method !== "DELETE") {
    method = "POST";
  }

  if (method === "GET") {
    const qr = queryString.stringify({ ...data });
    if (qr !== "") {
      path = path + "?" + qr;
    }
    data = null;
  }

  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      return resolve({
        code: 408,
        data: "Hết thời gian yêu cầu máy chủ",
        type: "error"
      });
    }, 30000);

    const resfunc = response => {
      clearTimeout(timeoutId);

      if (!response) {
        return resolve({ code: 503, message: "no_response", type: "error" });
      }

      if (!response.ok && response.status === 500) {
        return response
          .text()
          .then(msg =>
            resolve({ code: response.status, message: msg, type: "error" })
          );
      }

      if (!response.ok) {
        return resolve({
          code: response.status,
          message: response ? response.statusText : "",
          type: "error"
        });
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response
          .text()
          .then(msg =>
            resolve({ code: response.status, message: msg, type: "warning" })
          );
      }

      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      }

      return response.text();
    };

    const errfunc = err => {
      console.error(err);
      clearTimeout(timeoutId);
      return resolve({ code: 500, message: "Quá thời gian", type: "error" });
    };

    fetch(path, {
      method: method,
      mode: "cors",
      headers: getHeaders(),
      body: data !== null ? JSON.stringify(data) : null
    })
      .then(resfunc, errfunc)
      .then(resdata => {
        if (!resdata) {
          // TODO throw new Error(MESSAGE.cscore_tnn_ERROR);
          return resolve({ code: 200, data: [], type: "success" });
        }

        // console.info("APIService successful at ", resdata);
        if (resdata.code) {
          return resdata;
        }

        return resolve({ code: 200, data: resdata, type: "success" });
      });
  });
}

function callAPIUploadFile({ data }) {
  const method = "POST";
  return fetch(API_DMS_URI + `upload`, {
    method: method,
    body: data,
    headers: getHeaderFile()
  })
    .then(response => {
      if (!response) {
        // TODO
        return;
      }

      if (!response.ok) {
        // TODO
        return;
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response.json().then(err => {
          throw new Error(err && err.message);
        });
      }

      return response.json();
    })
    .then(resdata => {
      if (!resdata) {
        // throw new Error(MESSAGE.cscore_tnn_ERROR);
        return;
      }
      return resdata;
    });
}

function callAPIDownloadFile({ data }) {
  const path = API_DMS_URI + "download";
  const method = "POST";

  let canopen = false;
  if (data && data.file_name) {
    let arr = data.file_name.split(".");
    if (arr && arr.length > 0 && arr[arr.length - 1].toUpperCase() === "PDF") {
      canopen = true;
    }
  }

  if (canopen) {
    return fetch(path, {
      method: method,
      headers: getHeaders(),
      responseType: "blob",
      body: data !== null ? JSON.stringify(data) : null
    })
      .then(response => {
        if (!response) {
          // TODO
          return;
        }

        if (!response.ok) {
          // TODO
          return;
        }

        // lỗi hệ thống k xử lý được?
        if (response.status === 299) {
          return response.json().then(err => {
            throw new Error(err && err.message);
          });
        }

        return response.arrayBuffer();
      })
      .then(resdata => {
        if (!resdata) {
          // TODO throw new Error(MESSAGE.cscore_tnn_ERROR);
          return;
        }

        window.open(
          URL.createObjectURL(new Blob([resdata], { type: "application/pdf" }))
        );
      });
  }

  return fetch(path, {
    method: method,
    headers: getHeaders(),
    responseType: "blob",
    body: data !== null ? JSON.stringify(data) : null
  })
    .then(response => {
      if (!response) {
        // TODO
        return;
      }

      if (!response.ok) {
        // TODO
        return;
      }

      // lỗi hệ thống k xử lý được?
      if (response.status === 299) {
        return response.json().then(err => {
          throw new Error(err && err.message);
        });
      }

      return response.blob();
    })
    .then(resdata => {
      if (!resdata) {
        return;
      }

      const url = window.URL.createObjectURL(resdata);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", data.file_name);
      document.body.appendChild(link);
      link.click();
    });
}
export default class Api_DanhMuc {
  UpsertSanPham = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dmsanpham/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteSanPham = async ({ id } = {}) =>
    callAPI({ path: API_CORE_URI + `dmsanpham/delete/${id}`, method: "POST" });
  GetSanPhambyId = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dmsanpham/${id}`,
      method: "GET",
      data: {}
    });
  GetListSanPhams = async ({ data } = {}) =>
    callAPI({
      path: API_CORE_URI + `dmsanphams`,
      method: "POST",
      data: data || {}
    });

  UpsertThoiTietCucDoan = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_thoitietcucdoan/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThoiTietCucDoan = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thoitietcucdoan/delete/${id}`,
      method: "POST"
    });
  GetThoiTietCucDoan = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thoitietcucdoan/${id}`,
      method: "GET",
      data: {}
    });
  GetListThoiTietCucDoans = async ({ data } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thoitietcucdoans`,
      method: "POST",
      data: data || {}
    });

  UpsertBenhHai = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_benhhai/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteBenhHai = async ({ id } = {}) =>
    callAPI({ path: API_CORE_URI + `dm_benhhai/delete/${id}`, method: "POST" });
  GetBenhHai = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_benhhai/${id}`,
      method: "GET",
      data: {}
    });
  GetListBenhHais = async ({ data } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_benhhais`,
      method: "POST",
      data: data || {}
    });

  UpsertThuocTruSau = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_thuoctrusau/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThuocTruSau = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thuoctrusau/delete/${id}`,
      method: "POST"
    });
  GetThuocTruSau = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thuoctrusau/${id}`,
      method: "GET",
      data: {}
    });
  GetListThuocTruSaus = async ({ data } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thuoctrusaus`,
      method: "POST",
      data: data || {}
    });

  UpsertPhanBon = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_phanbon/upsert",
      method: "POST",
      data: data || {}
    });
  DeletePhanBon = async ({ id } = {}) =>
    callAPI({ path: API_CORE_URI + `dm_phanbon/delete/${id}`, method: "POST" });
  GetPhanBon = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_phanbon/${id}`,
      method: "GET",
      data: {}
    });
  GetListPhanBons = async ({ data } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_phanbons`,
      method: "POST",
      data: data || {}
    });

  UpsertThucAn = async ({ data }) =>
    callAPI({
      path: API_CORE_URI + "dm_thucan/upsert",
      method: "POST",
      data: data || {}
    });
  DeleteThucAn = async ({ id } = {}) =>
    callAPI({ path: API_CORE_URI + `dm_thucan/delete/${id}`, method: "POST" });
  GetThucAn = async ({ id } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thucan/${id}`,
      method: "GET",
      data: {}
    });
  GetListThucAns = async ({ data } = {}) =>
    callAPI({
      path: API_CORE_URI + `dm_thucans`,
      method: "POST",
      data: data || {}
    });
}
